/**
 * @description Listens for components loaded on "rendercomplete" event and check for load of all components from componentsToLoad, when removes .js-preloader-full-page loader from page
 *
 * @listens "rendercomplete" event when element from componentsToLoad visible to user
 *
 * @returns {void} if no .js-preloader-full-page found on the page
 */
function APILoadedCheck() {
	let pagePreloader = document.querySelector( ".js-preloader-full-page" );
	if ( pagePreloader == null ) {
		return;
	}

	let componentsToLoad = [
		"students",
		"summary"
	];

	document.addEventListener( "rendercomplete", () => {
		window.rendered.map( element => {
			componentsToLoad = componentsToLoad.filter( component => component != element );
		} );

		if ( componentsToLoad.length == 0 ) {
			// TODO: its better to provide classname througn function arguments
			pagePreloader.classList.remove( "is-loading" );
		}
	} );
}

export { APILoadedCheck };